













import { Component, Vue, Prop } from 'vue-property-decorator';

const colorMap = {
  white: '#ffffff',
  grey: '#F2F2F2',
};
@Component
export default class FitBackground extends Vue {
  @Prop({ default: '#ffffff' }) public color!: string;

  get finalColor() {
    return colorMap[this.color] || this.color;
  }
}
